// Dữ liệu MẪU bảng phải của Mint-Training (TASKS · notis trong script board). TODO(A): nguồn thật khi có API đào tạo.

export interface DockTask {
  k: string;
  code: string;
  due: string;
  late: boolean;
  /** chỉ quản lý đào tạo thấy */
  mgr?: true;
}

export interface DockNoti {
  k: string;
  when: string;
  tone: 'mid' | 'done' | 'err';
  unread: boolean;
}

export const DOCK_TASKS: readonly DockTask[] = [
  { k: 'Làm khoá "Release B/L theo mức nợ"', code: 'TRN', due: '21/Oct/2026 · quá hạn', late: true },
  { k: 'Hoàn thành khoá "Gửi bill qua hệ thống"', code: 'TRN', due: '24/Oct/2026 17:30', late: false },
  { k: 'Gia hạn chứng chỉ Đại lý hải quan', code: 'CRT', due: '11/Nov/2026', late: false },
  { k: 'Duyệt kết quả nhập môn NGỌC THẢO', code: 'TRN', due: '29/Oct/2026', late: false, mgr: true },
];

export const DOCK_NOTIS: readonly DockNoti[] = [
  { k: 'SOP-BKG-03 vừa cập nhật — khoá Booking có 2 câu hỏi mới', when: '22/Oct/2026 08:10', tone: 'mid', unread: true },
  { k: 'TUANNT hoàn thành "Báo giá Live" · 90%', when: '21/Oct/2026 17:42', tone: 'done', unread: false },
  { k: 'Chứng chỉ của ThaoTN đã hết hạn 05/Oct/2026', when: '05/Oct/2026 07:00', tone: 'err', unread: false },
];

export const tasksFor = (manager: boolean): readonly DockTask[] => DOCK_TASKS.filter((t) => manager || !t.mgr);
